<template>
  <svg class="venue-scenery" :x="object.x || 0" :y="object.y || 0" :width="object.w || layout.w" :height="object.h || layout.h" :viewBox="`0 0 ${layout.w} ${layout.h}`" preserveAspectRatio="none" overflow="hidden" aria-hidden="true">
    <g :transform="config.vertical ? `translate(${layout.height} 0) rotate(90)` : undefined">
      <text v-if="config.showLabel" :x="layout.width / 2" y="27" text-anchor="middle" :style="labelStyle(Math.min(19, (layout.width - 16) / Math.max(1, String(object.label || object.name || '').length * 0.65)))">{{ object.label || object.name }}</text>
      <g v-for="(item, index) in layout.items" :key="index" :transform="`translate(${item.x} ${item.y})`" data-scenery-piece="">
        <template v-if="config.kind === 'beer-table'">
          <rect x="5" y="8" width="112" height="51" rx="6" fill="#000" opacity=".22" />
          <rect v-for="y in [6, 49]" :key="y" x="8" :y="y" width="104" height="8" rx="3" :fill="woodDark" />
          <rect x="3" y="22" width="114" height="22" rx="4" :fill="config.color" />
          <path d="M10 29H110 M10 37H110" :stroke="woodDark" stroke-width="1" opacity=".38" />
          <path d="M10 23H110" stroke="#eee9f7" stroke-width="2" opacity=".35" />
          <circle cx="24" cy="32" r="4" fill="#eee9f7" />
          <circle cx="95" cy="34" r="4" fill="#eee9f7" />
          <text v-if="config.showNumbers" x="60" y="38" text-anchor="middle" :style="labelStyle(12, '#302719')">{{ item.number }}</text>
        </template>
        <template v-else-if="config.kind === 'food-stall' || config.kind === 'beer-bar'">
          <rect x="7" y="10" width="108" height="87" rx="7" fill="#000" opacity=".24" />
          <rect x="5" y="12" width="108" height="76" rx="5" :fill="woodDark" />
          <rect x="12" y="40" width="94" height="33" rx="2" fill="#272130" />
          <rect x="5" y="70" width="108" height="14" rx="3" :fill="woodLight" />
          <path d="M10 76H107" stroke="#dce5fb" opacity=".5" />
          <rect x="2" y="4" width="114" height="35" rx="4" :fill="config.striped ? '#dce5fb' : config.color" />
          <template v-if="config.striped">
            <rect v-for="n in 6" :key="n" :x="3 + (n - 1) * 19" y="5" width="10" height="33" rx="2" :fill="config.color" />
          </template>
          <path d="M4 32H114" stroke="#15202b" stroke-width="2" opacity=".2" />
          <template v-if="config.kind === 'beer-bar'">
            <g v-for="x in [24, 94]" :key="x">
              <ellipse :cx="x" cy="55" rx="11" ry="14" :fill="woodLight" />
              <path :d="`M${x-8} 48h16 M${x-8} 61h16`" stroke="#514565" stroke-width="3" />
            </g>
            <path d="M49 65V49h9v5 M64 65V49h9v5" fill="none" stroke="#d5dbe0" stroke-width="3" />
          </template>
          <template v-else>
            <ellipse v-for="x in [24, 94]" :key="x" :cx="x" cy="59" rx="11" ry="6" fill="#ddd5eb" />
            <path d="M19 58h10 M89 58h10" stroke="#8e6bc4" stroke-width="3" stroke-linecap="round" />
          </template>
          <g v-if="config.kind === 'beer-bar'">
            <path d="M8 86H110" stroke="#dfe5ee" stroke-width="1" />
            <g v-for="x in [23,60,97]" :key="x"><ellipse :cx="x" cy="96" rx="8" ry="2" fill="#000" opacity=".25" /><circle :cx="x" cy="91" r="5" fill="#343b48" stroke="#c9d1dd" stroke-width="1" /></g>
            <path d="M39 65v-8h5v3M77 65v-8h5v3" fill="none" stroke="#eef1f7" stroke-width="2" />
            <rect x="48" y="73" width="23" height="6" rx="1" fill="#343b48" /><path d="M50 75H69M50 77H69" stroke="#a8b2c2" stroke-width=".6" />
          </g>
          <rect v-if="config.showNumbers" x="45" y="40" width="30" height="21" rx="4" fill="#231b30" />
          <text v-if="config.showNumbers" x="60" y="55" text-anchor="middle" :style="labelStyle(14)">{{ item.number }}</text>
        </template>
        <template v-else-if="config.kind === 'planter'">
          <ellipse cx="33" cy="37" rx="29" ry="26" fill="#000" opacity=".2" />
          <circle cx="30" cy="30" r="28" :fill="woodDark" />
          <circle cx="30" cy="30" r="24" fill="#282232" />
          <ellipse v-for="angle in [0,60,120]" :key="angle" cx="30" cy="30" rx="9" ry="25" :transform="`rotate(${angle} 30 30)`" :fill="config.color" stroke="#322a40" stroke-width="2" />
          <circle cx="30" cy="30" r="6" fill="#dce5fb" />
        </template>
        <VenueSceneryGlyph v-else :preset="layout.preset" :config="config" :number="item.number" />
      </g>
    </g>
  </svg>
</template>
<script>
import VenueSceneryGlyph from './VenueSceneryGlyph.vue'
import { sceneryLayout } from '../../common/venueScenery.js'
export default {
  name: 'VenueScenery', components: { VenueSceneryGlyph },
  props: { object: { type: Object, required: true } },
  computed: {
    layout() { return sceneryLayout(this.object.scenery) },
    config() { return this.layout.config },
    woodDark() { return this.config.wood === 'dark' ? '#363a45' : '#88909e' },
    woodLight() { return this.config.wood === 'dark' ? '#7b8595' : '#c1c8d3' },
  },
  methods: { labelStyle(size, fill = '#eee9f7') { return { fontSize: `${size}px`, fill, fontWeight: '700', letterSpacing: '0.04em', stroke: 'none' } } },
}
</script>
<style scoped>
.venue-scenery { pointer-events: none; }
</style>
